import React from 'react';
import Row from './Row';

const Body = ({columns, data}) => (
  <tbody>
    {data.map((tr, index) => (
      <Row key={index} row={tr} columns={columns} />
    ))}
  </tbody>
);

export default Body;
